var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { InlineFormFormat } from "../../../UI/FormFormat/FormFormat";
import TextField from "../../../Form/TextField";
import PopulationService from "../../../../Services/Population.service";
import usePagedSortedTable, { TotalPageMappers, } from "../../../Hooks/usePagedSortedTable";
import PageTitle from "../../../UI/PageTitle/PageTitle";
import { getPopulationSharedFiltersDetailPath } from "./AdminPopulationRoutes";
import DateService from "../../../../Services/Shared/Date.service";
import useService from "../../../Hooks/useService";
import ServiceResult, { Loaders, } from "../../../UI/ServiceResult/ServiceResult";
import NumberService from "../../../../Services/Shared/Number.service";
import { PersonMultiSearch, } from "../../../Presentational/Person/PersonSearch";
import PersonTypeDomainService from "../../../../Domain/PersonType/PersonType.service";
import SearchField from "../../../Form/SearchField";
import { PersonTypeSearch } from "../../../Presentational/PersonType/PersonTypeSearch";
const PAGE_SIZE = 50;
const PopulationIndex = () => {
    var _a, _b, _c;
    const hasSharedField = true;
    const [searchArgs, setSearchArgs] = useState({});
    const [populationMembersState, loadPopulationMembers] = useService(PopulationService.getMembersOfPopulations);
    const { table, dataState } = usePagedSortedTable({
        noDataComponent: "No filters found",
        searchArgs,
        getData: (sort, pageNumber, sArgs) => {
            return PopulationService.search(Object.assign(Object.assign({}, sArgs), { adHoc: false, allPopulations: true }), {
                max: PAGE_SIZE,
                offset: pageNumber * PAGE_SIZE,
                sort: sort === null || sort === void 0 ? void 0 : sort.sort,
                order: (sort === null || sort === void 0 ? void 0 : sort.order) === "asc" ? "ascnullsfirst" : "descnullslast",
            });
        },
        getNumPages: (result) => TotalPageMappers.EngagePagedResult(result, PAGE_SIZE),
        columns: [
            {
                title: "Name",
                sortId: "POPULATION_NAME",
                size: 3,
            },
            {
                title: "Owner",
                sortId: "POPULATION_OWNER_FIRSTNAME",
                size: 2,
            },
            {
                title: "Person Types",
                sortId: "POPULATION_PERSON_TYPE",
                size: 2,
            },
            {
                title: "Created Date",
                sortId: "POPULATION_CREATED_DATE",
                size: 2,
            },
            {
                title: "# Users",
                align: "center",
            },
        ],
        rows: ({ data }) => data.map((population) => {
            return [
                _jsx(Link, { to: getPopulationSharedFiltersDetailPath(population.id), children: population.name }, 0),
                population.owner.fullName,
                population.personType.name,
                DateService.displayWithTime(new Date(population.backing.filter.createdDate.toString())),
                _jsx(ServiceResult, { state: populationMembersState, loader: Loaders.skeleton(), children: (members) => {
                        var _a;
                        const count = (_a = members === null || members === void 0 ? void 0 : members.find((member) => member.populationId === population.id)) === null || _a === void 0 ? void 0 : _a.numberOfPeopleSharedWith;
                        return count ? NumberService.format(count) : null;
                    } }, 1),
            ];
        }),
    });
    useEffect(() => {
        var _a, _b;
        if (dataState.wasSuccessful) {
            const ids = (_b = (_a = dataState.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.map((population) => {
                return population.id;
            });
            if (ids) {
                loadPopulationMembers(ids);
            }
        }
    }, [dataState.wasSuccessful, (_a = dataState.data) === null || _a === void 0 ? void 0 : _a.data, loadPopulationMembers]);
    return (_jsx(_Fragment, { children: hasSharedField && (_jsx(_Fragment, { children: _jsxs("div", { className: "container-fluid pb-5 mt-3", children: [_jsxs(PageTitle, { className: "mb-3", children: ["Filters", " ", ((_b = dataState.data) === null || _b === void 0 ? void 0 : _b.total) ? `(${(_c = dataState.data) === null || _c === void 0 ? void 0 : _c.total})` : ""] }), _jsx("div", { className: "mb-3", children: _jsxs(InlineFormFormat, { saveButtonContents: "Search", handleSubmit: (formState) => __awaiter(void 0, void 0, void 0, function* () {
                                var _d, _e, _f;
                                setSearchArgs({
                                    query: formState.query,
                                    ownerIds: (_d = formState.ownerIds) === null || _d === void 0 ? void 0 : _d.map((person) => person.personId),
                                    personTypeIds: ((_e = formState.personType) === null || _e === void 0 ? void 0 : _e.id)
                                        ? [(_f = formState.personType) === null || _f === void 0 ? void 0 : _f.id]
                                        : [],
                                });
                            }), children: [_jsx(TextField, { name: "query", label: "Search Name" }), _jsx(SearchField, { name: "ownerIds", label: "Owner", as: (provided) => (_jsx(PersonMultiSearch, Object.assign({}, provided, { personTypeInternalNames: [
                                            PersonTypeDomainService.StaffPersonTypeInternalName,
                                            PersonTypeDomainService.FacultyPersonTypeInternalName,
                                        ] }))) }), _jsx(SearchField, { label: "Person Type", name: "personType", 
                                    // @ts-expect-error - TS2322 - Type '{ placeholder: string | null | undefined; hasError: boolean; errorMessage: string | null | undefined; disabled: boolean | null | undefined; "aria-label": string; }' is not assignable to type 'never'.
                                    as: (provided) => _jsx(PersonTypeSearch, Object.assign({}, provided)) })] }) }), _jsx("div", { className: "py-2", children: table })] }) })) }));
};
export default PopulationIndex;
